(function () {
  var FKB_B3G1 = {
    offerId: 163165,
    offerRoot: '163165',
    productId: 9022266802395,
    qualifyingVariantId: 48483830792411,
    giftVariantId: 48484066689243,
    minQty: 3
  };

  function patchB3G1OfferConfig() {
    var offers = window.fgData && window.fgData.offers;
    if (!offers || !offers.length) {
      return false;
    }

    offers.forEach(function (offer) {
      if (offer.id !== FKB_B3G1.offerId) {
        return;
      }

      if (offer.gift_settings) {
        offer.gift_settings.auto_add_all_gifts = true;
      }

      if (offer.offer_conditions && offer.offer_conditions[0] && offer.offer_conditions[0].product_narrow) {
        offer.offer_conditions[0].product_narrow.forEach(function (narrow) {
          if (narrow.value && narrow.value[FKB_B3G1.productId]) {
            narrow.value[FKB_B3G1.productId].variants = [{ id: FKB_B3G1.qualifyingVariantId }];
          }
        });
      }

      if (offer.gift_items && offer.gift_items[0]) {
        offer.gift_items[0].variant_shopify_id = FKB_B3G1.giftVariantId;
      }
    });

    return true;
  }

  function cartHasGift(cart) {
    return cart.items.some(function (item) {
      return isBogosGiftLine(item);
    });
  }

  function isBogosGiftLine(item) {
    if (!item) {
      return false;
    }

    var properties = item.properties || {};

    if (properties._bogos_trigger_type === 'gift_func') {
      return true;
    }

    if (properties._bogos_trigger_id) {
      return true;
    }

    if (item.handle && String(item.handle).indexOf('sca_clone_freegift') !== -1) {
      return true;
    }

    if (item.url && String(item.url).indexOf('sca_clone_freegift') !== -1) {
      return true;
    }

    return item.variant_id === FKB_B3G1.giftVariantId;
  }

  function tagBogosGiftRows(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return;
    }

    cart.items.forEach(function (item) {
      if (!isBogosGiftLine(item)) {
        return;
      }

      document.querySelectorAll('[data-line="' + item.key + '"]').forEach(function (row) {
        row.classList.add('fkb-bogos-free-gift');
        row.setAttribute('data-fkb-bogos-free-gift', 'true');

        if (!row.id) {
          row.id = 'fkb-bogos-free-gift-' + String(item.key).replace(/[^a-zA-Z0-9_-]/g, '-');
        }
      });
    });
  }

  function countQualifyingQty(cart) {
    return cart.items.reduce(function (sum, item) {
      if (isBogosGiftLine(item)) {
        return sum;
      }

      if (item.product_id === FKB_B3G1.productId || item.variant_id === FKB_B3G1.qualifyingVariantId) {
        return sum + item.quantity;
      }

      return sum;
    }, 0);
  }

  function refreshCartUi(cart) {
    tagBogosGiftRows(cart);

    if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
      window.sharedFunctions.updateSidebarCart(cart);
      return;
    }

    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
    }
  }

  async function ensureB3G1Gift() {
    if (window.__fkbB3G1Running) {
      return;
    }

    window.__fkbB3G1Running = true;

    try {
      patchB3G1OfferConfig();

      var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
        return response.json();
      });

      if (countQualifyingQty(cart) < FKB_B3G1.minQty || cartHasGift(cart)) {
        return;
      }

      if (window.FGSECOMAPP && typeof window.FGSECOMAPP.fetchCheckoutEvents === 'function') {
        window.FGSECOMAPP.fetchCheckoutEvents();
        await new Promise(function (resolve) {
          window.setTimeout(resolve, 1200);
        });

        cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
          return response.json();
        });

        if (cartHasGift(cart)) {
          refreshCartUi(cart);
          return;
        }
      }

      await fetch('/cart/add.js?sca_add_gift=1', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: FKB_B3G1.giftVariantId,
            quantity: 1,
            properties: {
              _bogos_trigger_id: FKB_B3G1.offerRoot,
              _bogos_trigger: 'GF_' + FKB_B3G1.offerRoot,
              _bogos_trigger_type: 'gift_func'
            }
          }]
        })
      });

      cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
        return response.json();
      });

      refreshCartUi(cart);
      document.dispatchEvent(new CustomEvent('fg-gifts:updated'));
    } catch (error) {
      console.warn('Fake Bake B3G1 gift bridge:', error);
    } finally {
      window.__fkbB3G1Running = false;
    }
  }

  function scheduleEnsureB3G1Gift() {
    window.clearTimeout(window.__fkbB3G1Timer);
    window.__fkbB3G1Timer = window.setTimeout(ensureB3G1Gift, 400);
  }

  function notifyBogosCartChange() {
    patchB3G1OfferConfig();

    if (window.FGSECOMAPP && typeof window.FGSECOMAPP.fetchCheckoutEvents === 'function') {
      window.FGSECOMAPP.fetchCheckoutEvents();
    } else {
      document.dispatchEvent(new CustomEvent('bogos:message'));
    }

    scheduleEnsureB3G1Gift();
  }

  function patchEllaCartHooks() {
    if (!window.sharedFunctions || window.sharedFunctions.__fkbBogosPatched) {
      return;
    }

    var originalUpdateSidebarCart = window.sharedFunctions.updateSidebarCart;

    if (typeof originalUpdateSidebarCart === 'function') {
      window.sharedFunctions.updateSidebarCart = function (cart) {
        var result = originalUpdateSidebarCart.apply(this, arguments);
        window.setTimeout(notifyBogosCartChange, 250);
        return result;
      };
    }

    window.sharedFunctions.__fkbBogosPatched = true;
  }

  function watchCartDrawerOpen() {
    if (window.__fkbBogosDrawerObserver) {
      return;
    }

    window.__fkbBogosDrawerObserver = new MutationObserver(function () {
      if (document.body.classList.contains('cart-sidebar-show')) {
        notifyBogosCartChange();
      }
    });

    window.__fkbBogosDrawerObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function boot() {
    patchB3G1OfferConfig();
    patchEllaCartHooks();
    watchCartDrawerOpen();
    scheduleEnsureB3G1Gift();

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(tagBogosGiftRows)
      .catch(function () {});
  }

  if (!patchB3G1OfferConfig()) {
    var attempts = 0;
    var patchTimer = window.setInterval(function () {
      attempts += 1;
      if (patchB3G1OfferConfig() || attempts >= 150) {
        window.clearInterval(patchTimer);
      }
    }, 100);
  }

  document.addEventListener('fg-app:start', boot);
  document.addEventListener('fg-app:end', boot);
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('fg-gifts:updated', boot);
  document.addEventListener('cart-update', function (event) {
    tagBogosGiftRows(event.detail);
  });
  boot();
  window.setTimeout(boot, 2000);
})();
